module.exports = __webpack_public_path__ + "images/feature/roadmapimg_1010_gif-33b725f96341af74cd939f428b75ff75.gif";